import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "name", "alt", "size"];
import { Image } from '../Image';
import { getImageUrl } from 'trellis-assets/pictograms/utils/getImageUrl';
import { useImageSize } from 'trellis-assets/pictograms/utils';

/**
 * Props for the Pictogram component.
 * Extends IllustrationProps but omits width, height, isThemeable, bordered, and shape props.
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A component for displaying modernized pictograms from the trellis-assets library.
 * Pictograms are curated, standardized graphical representations designed for
 * consistent use across the HubSpot product suite. Unlike the Illustration component,
 * Pictogram is specifically tailored for the modernized pictogram set and does not
 * support custom dimensions or theme-switching.
 *
 * @example
 * Basic usage:
 * ```tsx
 * <Pictogram name="Calling" />
 * ```
 *
 * @see {@link https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-pictogram--page Storybook documentation}
 */
export const Pictogram = _ref => {
  let {
      disabled = false,
      name,
      alt = '',
      size = 'md'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const imageSrc = getImageUrl(name);
  const sizePx = useImageSize(size);
  return /*#__PURE__*/_jsx(Image, Object.assign({
    objectFit: "contain",
    src: imageSrc,
    alt: alt,
    responsive: false,
    inlineSize: sizePx,
    blockSize: sizePx,
    opacity: disabled ? 0.5 : 1
  }, rest));
};
Pictogram.displayName = 'Pictogram';